import { Card } from '../../components/ui/Card'
import { Icon } from '../../components/ui/Icon'
import { RFQ_BUNDLED_NOTE } from './domain'

/**
 * UID-198 (Gate 2 UX spec §3.3, ADR-0074) — the RFQ detail page's
 * always-visible bundled-quote callout. Mounted as `RfqDetailServicesCard`'s
 * sibling inside `.rfq-detail-main` (`RfqDetailPage.tsx`), gated on
 * `rfq.bundled === true`, independent of quote-load state (ADR-0074's
 * placement decision — NOT inside `RfqCard`, so it renders below the
 * services section as the acceptance criterion requires).
 *
 * Static, non-interactive, read-only content — no button/link, no new focus
 * stop, no new target-size requirement. Not a color-only signal (WCAG 1.4.1):
 * the amber tint is paired with a lock icon AND the "Bundled quote" heading
 * AND the full explanatory sentence — three redundant non-color cues.
 */
export function RfqBundledCallout() {
  return (
    <Card className="rfq-bundled-callout">
      <Icon name="lock" className="rfq-bundled-callout-icon" />
      <div className="rfq-bundled-callout-body">
        <h2 className="rfq-bundled-callout-heading">Bundled quote</h2>
        <p className="rfq-bundled-callout-note">{RFQ_BUNDLED_NOTE}</p>
      </div>
    </Card>
  )
}
